<template>
  <Selector :options="optionList" @dataChange="change"></Selector>
</template>

<script>
import Selector from './Selector.vue'

export default {
  name: 'selector',
  components: { Selector },
  props: {
    placeholder: String,
    options: {
      type: String,
      default: 'process'
    },
    selected: {
      type: Number,
      default(){
        return 0
      }
    }
  },
  data() {
    return {
      protocolOptions: [
        {value:'name', label: '프로토콜명(한글)', select: true},
        {value:'nameEng', label: '프로토콜명(영문)',},
        {value:'userName', label: '작성자명', },
          
/*      검색엔진을 타지 않는 조회 조건 주석처리.
        {value:'nodeContent', label: '위키내용', },
        {value:'content', label: '트리 노드명', },
        {value:'nodeMemo', label: '메모', },*/
        /*{value:'equipment', label: '장비', },
        {value:'measurement', label: '측정목적', },
        {value:'analysis', label: '분석목적', },
        {value:'material', label: '재료', },*/
        
      ],
      processOptions: [
        {value:'name', label:'공정도명(한글)', select: true},
        {value:'name_eng', label:'공정도명(영문)'},
        {value:'username', label:'작성자명'},
      ],
      optionList: null
    }
  },
  watch: {
  },
  mounted() {
    if(this.options === 'process') {
      this.optionList = this.processOptions
    } else {
      this.optionList = this.protocolOptions
    }
  },
  methods : {
    change(value) {
      // console.log(value)
      this.$emit('change', value);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

